<template>
  <el-dialog
    title="选择OA流程工单"
    :visible.sync="visible"
    width="70%"
    @close="handleClose"
  >
    <el-card class="search-card">
      <el-form :inline="true" :model="conditions" class="search-form">
        <el-form-item>
          <el-input v-model="conditions.createUserName" placeholder="请输入申请人" clearable />
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="conditions.startTime"
            type="datetime"
            placeholder="请输入开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="conditions.endTime"
            type="datetime"
            placeholder="请输入结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryWorkOrders">
            <i class="el-icon-search"></i>
            搜索
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <el-table ref="workOrderTable" :data="workOrders" border style="width: 100%" v-loading="loading"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column prop="id" label="工单编号" align="center" />
        <el-table-column prop="textfield3" label="标题" align="center" />
        <el-table-column prop="create_user_name" label="申请人" align="center" />
        <el-table-column prop="create_time" label="创建时间" align="center" />
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ getWorkOrderState(scope.row) }}
          </template>
        </el-table-column>
      </el-table>

      <div style="text-align: right; margin-top: 15px;">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="confirmSelect">确认选择</el-button>
      </div>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="pagination"
      />
    </el-card>
  </el-dialog>
</template>

<script>
import { queryOaWorkflowFormData } from '@/api/oa/newOaWorkflowApi'

export default {
  name: 'SelectOaWorkflow',
  data() {
    return {
      visible: false,
      loading: false,
      workOrders: [],
      total: 0,
      flowId: '',
      selectedRows: [],
      page: {
        current: 1,
        size: 10
      },
      conditions: {
        createUserName: '',
        startTime: '',
        endTime: ''
      }
    }
  },
  methods: {
    open(params) {
      this.visible = true
      this.flowId = (params && params.flowId) || ''
      this.page.current = 1
      this.loadWorkOrders()
    },
    async loadWorkOrders() {
      this.loading = true
      try {
        const params = {
          ...this.conditions,
          flowId: this.flowId,
          state: '1005',
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await queryOaWorkflowFormData(params)
        this.workOrders = data || []
        this.total = total || 0
      } catch (error) {
        console.error('获取OA工单列表失败:', error)
        this.$message.error('获取OA工单列表失败')
      } finally {
        this.loading = false
      }
    },
    queryWorkOrders() {
      this.page.current = 1
      this.loadWorkOrders()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.loadWorkOrders()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.loadWorkOrders()
    },
    viewDetail(row) {
      this.$router.push({
        path: '/views/oa/newOaWorkflowDetail',
        query: {
          id: row.id,
          flowId: row.flowId
        }
      })
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows
    },
    confirmSelect() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一个工单')
        return
      }
      const ids = this.selectedRows.map(row => row.id).join(',')
      const flowIds = this.selectedRows.map(row => row.flowId).filter(Boolean).join(',')
      this.$emit('select', {
        oaWorkflowId: ids,
        oaWorkflowFlowId: flowIds
      })
      this.visible = false
    },
    selectWorkOrder(row) {
      this.$emit('select', {
        oaWorkflowId: row.id,
        oaWorkflowFlowId: row.flowId
      })
      this.visible = false
    },
    getWorkOrderState(row) {
      if (!Object.prototype.hasOwnProperty.call(row, 'state')) return '未知'
      const stateMap = {
        '1001': '申请',
        '1002': '待审核',
        '1003': '退回',
        '1004': '转单',
        '1005': '办结'
      }
      return stateMap[row.state] || '未知'
    },
    handleClose() {
      this.conditions = {
        createUserName: '',
        startTime: '',
        endTime: ''
      }
      this.page.current = 1
      this.selectedRows = []
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.search-card {
  margin-bottom: 20px;

  .search-form {
    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.table-card {
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
